import styled from "styled-components";

import { BaseCell } from "@similarweb/pro-logic-components";

export const StyledBaseCell = styled(BaseCell)`
    display: flex;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: flex-start;
    padding: 12px 0;
    min-height: 36px;
    position: relative;
    width: 100%;
`;
